import styles from "scss/Table.module.scss";
import React, { useContext, useMemo } from "react";
import { Box } from '@mui/material';
import { DataGrid as MuiDataGrid,  DataGridProps, GridColumns, GridSortModel } from '@mui/x-data-grid';
import { useIntl } from "react-intl";
import { getMuiLocaleText } from "utils/getMUILocaleText";
import { LanguageContext } from "LanguageProvider";

interface IDataGridProps extends DataGridProps {
  rows: any[];
  isLoading: boolean;
  columns: GridColumns<any>;
  pageSize: number;
  Toolbar?: React.JSXElementConstructor<any>;
  handleChangePage: (newPage: number) => void;
  handleChangeRowsPerPage: (newPageSize: number) => void;
  handleSort: (newSortModel: GridSortModel) => void;
  sortModel?: GridSortModel;
  rowCount?: number;
};

export const DataGrid = (dataGridProps: IDataGridProps) => {

  const {
    rows = [],
    isLoading,
    columns,
    pageSize,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSort,
    sortModel,
    rowCount = 0
  } = dataGridProps;
  const { formatMessage } = useIntl();
  const languageContext = useContext(LanguageContext);
  const locale = languageContext?.locale;
  const localeText = useMemo(() => getMuiLocaleText(locale ?? "es", formatMessage), [locale, formatMessage]);

  return (
    <Box className={styles.DataGridContainer}>
      <MuiDataGrid
        rows={rows}
        loading={isLoading}
        columns={columns}
        pagination
        pageSize={pageSize}
        getRowId={(row) => row._id}
        disableSelectionOnClick
        paginationMode="server"
        onPageChange={(newPage) => handleChangePage(newPage)}
        onPageSizeChange={(newPageSize) => handleChangeRowsPerPage(newPageSize)}
        sortModel={sortModel}
        onSortModelChange={(newSortModel) => handleSort(newSortModel)}
        hideFooter={rows.length === 0}
        autoHeight={rows.length !== 0}
        rowsPerPageOptions={[10, 20, 25]}
        rowCount={rowCount}
        localeText={localeText}
        rowHeight={80}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "#718096",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeadersInner, & .MuiDataGrid-virtualScrollerRenderZone":
            {
              padding: "0px 0px",
            },
        }}
      />
    </Box>
  );
}